"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TropicalResortRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Units_1 = require("../../../Units");
var TropicalResortRebalanced = (function (_super) {
    __extends(TropicalResortRebalanced, _super);
    function TropicalResortRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.TROPICAL_RESORT_REBALANCED,
            tags: [Tags_1.Tags.BUILDING],
            cost: 11,
            productionBox: Units_1.Units.of({ megacredits: 3, heat: -2 }),
            metadata: {
                cardNumber: '098',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().heat(2).br;
                        pb.plus().megacredits(3);
                    });
                }),
                description: 'Reduce your heat production 2 steps and increase your M€ production 3 steps.',
                victoryPoints: 2,
            },
        }) || this;
    }
    TropicalResortRebalanced.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.HEAT) >= 2;
    };
    TropicalResortRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, -2);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
        return undefined;
    };
    TropicalResortRebalanced.prototype.getVictoryPoints = function () {
        return 2;
    };
    return TropicalResortRebalanced;
}(Card_1.Card));
exports.TropicalResortRebalanced = TropicalResortRebalanced;
//# sourceMappingURL=TropicalResortRebalanced.js.map